<template>
  <div id="app" class="container-fluid">
    <g-header></g-header>
    <Navbar></Navbar>
    <router-view/>
    <Relatedlink></Relatedlink>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "components/header";
import Navbar from "components/navbar";
import Relatedlink from "components/relatedlink";
import Footer from "components/footer";
export default {
  data() {
    return {};
  },
  components: {
    "g-header": Header,
    Navbar,
    Relatedlink,
    Footer
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
#app {
  width: 1200px;
  /* border: 1px solid red;s */
  margin: 0 auto;
  box-shadow: 0 0 5px #a5a6a8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue